export const InAppPositionTopLeftIcon = () => (
  <svg
    viewBox="0 0 48 38"
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M44 38H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4zm-2.5-3c1.933 0 3.5-1.508 3.5-3.368V6.368C45 4.508 43.433 3 41.5 3h-35C4.567 3 3 4.508 3 6.368v25.264C3 33.492 4.567 35 6.5 35h35z"
        fill="#374151"
        fillRule="nonzero"
      ></path>
      <path
        d="M21.5 18h-15c-.828 0-1.5-.613-1.5-1.368V6.368C5 5.613 5.672 5 6.5 5h15c.828 0 1.5.613 1.5 1.368v10.264c0 .755-.672 1.368-1.5 1.368zm-14.4-.684c-.762 0-1.38-.548-1.38-1.225V6.91c0-.677.618-1.225 1.38-1.225h13.8c.762 0 1.38.548 1.38 1.225v9.182c0 .677-.618 1.225-1.38 1.225H7.1z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppPositionTopCenterIcon = () => (
  <svg
    viewBox="0 0 48 38"
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M44 38H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4zm-2.5-3c1.933 0 3.5-1.508 3.5-3.368V6.368C45 4.508 43.433 3 41.5 3h-35C4.567 3 3 4.508 3 6.368v25.264C3 33.492 4.567 35 6.5 35h35z"
        fill="#374151"
        fillRule="nonzero"
      ></path>
      <path
        d="M31.5 18h-15c-.828 0-1.5-.613-1.5-1.368V6.368C15 5.613 15.672 5 16.5 5h15c.828 0 1.5.613 1.5 1.368v10.264c0 .755-.672 1.368-1.5 1.368zm-14.4-.684c-.762 0-1.38-.548-1.38-1.225V6.91c0-.677.618-1.225 1.38-1.225h13.8c.762 0 1.38.548 1.38 1.225v9.182c0 .677-.618 1.225-1.38 1.225H17.1z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppPositionTopRightIcon = () => (
  <svg
    viewBox="0 0 48 38"
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M44 38H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4zm-2.5-3c1.933 0 3.5-1.508 3.5-3.368V6.368C45 4.508 43.433 3 41.5 3h-35C4.567 3 3 4.508 3 6.368v25.264C3 33.492 4.567 35 6.5 35h35z"
        fill="#374151"
        fillRule="nonzero"
      ></path>
      <path
        d="M41.5 18h-15c-.828 0-1.5-.613-1.5-1.368V6.368C25 5.613 25.672 5 26.5 5h15c.828 0 1.5.613 1.5 1.368v10.264c0 .755-.672 1.368-1.5 1.368zm-14.4-.684c-.762 0-1.38-.548-1.38-1.225V6.91c0-.677.618-1.225 1.38-1.225h13.8c.762 0 1.38.548 1.38 1.225v9.182c0 .677-.618 1.225-1.38 1.225H27.1z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppPositionCenterIcon = () => (
  <svg
    viewBox="0 0 48 38"
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M44 38H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4zm-2.5-3c1.933 0 3.5-1.508 3.5-3.368V6.368C45 4.508 43.433 3 41.5 3h-35C4.567 3 3 4.508 3 6.368v25.264C3 33.492 4.567 35 6.5 35h35z"
        fill="#374151"
        fillRule="nonzero"
      ></path>
      <path
        d="M31.5 25h-15c-.828 0-1.5-.613-1.5-1.368V13.368c0-.755.672-1.368 1.5-1.368h15c.828 0 1.5.613 1.5 1.368v10.264c0 .755-.672 1.368-1.5 1.368zm-14.4-.684c-.762 0-1.38-.548-1.38-1.225V13.91c0-.677.618-1.225 1.38-1.225h13.8c.762 0 1.38.548 1.38 1.225v9.182c0 .677-.618 1.225-1.38 1.225H17.1z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppPositionBottomLeftIcon = () => (
  <svg
    viewBox="0 0 48 38"
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M44 38H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4zm-2.5-3c1.933 0 3.5-1.508 3.5-3.368V6.368C45 4.508 43.433 3 41.5 3h-35C4.567 3 3 4.508 3 6.368v25.264C3 33.492 4.567 35 6.5 35h35z"
        fill="#374151"
        fillRule="nonzero"
      ></path>
      <path
        d="M21.5 33h-15c-.828 0-1.5-.613-1.5-1.368V21.368C5 20.613 5.672 20 6.5 20h15c.828 0 1.5.613 1.5 1.368v10.264c0 .755-.672 1.368-1.5 1.368zm-14.4-.684c-.762 0-1.38-.548-1.38-1.225V21.91c0-.677.618-1.225 1.38-1.225h13.8c.762 0 1.38.548 1.38 1.225v9.182c0 .677-.618 1.225-1.38 1.225H7.1z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppPositionBottomCenterIcon = () => (
  <svg
    viewBox="0 0 48 38"
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M44 38H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4zm-2.5-3c1.933 0 3.5-1.508 3.5-3.368V6.368C45 4.508 43.433 3 41.5 3h-35C4.567 3 3 4.508 3 6.368v25.264C3 33.492 4.567 35 6.5 35h35z"
        fill="#374151"
        fillRule="nonzero"
      ></path>
      <path
        d="M32.5 33h-15c-.828 0-1.5-.613-1.5-1.368V21.368c0-.755.672-1.368 1.5-1.368h15c.828 0 1.5.613 1.5 1.368v10.264c0 .755-.672 1.368-1.5 1.368zm-14.4-.684c-.762 0-1.38-.548-1.38-1.225V21.91c0-.677.618-1.225 1.38-1.225h13.8c.762 0 1.38.548 1.38 1.225v9.182c0 .677-.618 1.225-1.38 1.225H18.1z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppPositionBottomRightIcon = () => (
  <svg
    viewBox="0 0 48 38"
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M44 38H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4zm-2.5-3c1.933 0 3.5-1.508 3.5-3.368V6.368C45 4.508 43.433 3 41.5 3h-35C4.567 3 3 4.508 3 6.368v25.264C3 33.492 4.567 35 6.5 35h35z"
        fill="#374151"
        fillRule="nonzero"
      ></path>
      <path
        d="M41.5 33h-15c-.828 0-1.5-.613-1.5-1.368V21.368c0-.755.672-1.368 1.5-1.368h15c.828 0 1.5.613 1.5 1.368v10.264c0 .755-.672 1.368-1.5 1.368zm-14.4-.684c-.762 0-1.38-.548-1.38-1.225V21.91c0-.677.618-1.225 1.38-1.225h13.8c.762 0 1.38.548 1.38 1.225v9.182c0 .677-.618 1.225-1.38 1.225H27.1z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppBoldTextStyleIcon = () => (
  <svg
    className="w-[28px] h-[28px]"
    width="28"
    height="28"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5761 10.301C14.5464 9.29027 15.1412 7.92437 15.1412 6.42275V6.1282C15.1412 3.02099 12.5971 0.5 9.46106 0.5H0.91624C0.480192 0.5 0.125 0.855192 0.125 1.29124V20.9019C0.125 21.3726 0.506181 21.7537 0.976883 21.7537H10.1801C13.5588 21.7537 16.2963 19.0335 16.2963 15.6751V15.3574C16.2963 13.2494 15.2163 11.3925 13.5761 10.301ZM2.89723 3.27223H9.38598C11.0349 3.27223 12.369 4.55438 12.369 6.13975V6.41409C12.369 7.99657 11.032 9.28161 9.38598 9.28161H2.89723V3.27223ZM13.4837 15.6722C13.4837 17.4886 11.9907 18.9613 10.1483 18.9613H2.89723V12.0712H10.1483C11.9907 12.0712 13.4837 13.5439 13.4837 15.3603V15.6722Z"
      fill="#374151"
    />
  </svg>
);

export const InAppItalicTextStyleIcon = () => (
  <svg
    className="w-[28px] h-[28px]"
    width="28"
    height="28"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2825 0.25H4.24679C4.12421 0.25 4.02391 0.350298 4.02391 0.472884V2.25595C4.02391 2.37854 4.12421 2.47884 4.24679 2.47884H9.29511L4.94888 17.6349H0.429915C0.307329 17.6349 0.207031 17.7352 0.207031 17.8578V19.6409C0.207031 19.7635 0.307329 19.8638 0.429915 19.8638H12.4656C12.5882 19.8638 12.6885 19.7635 12.6885 19.6409V17.8578C12.6885 17.7352 12.5882 17.6349 12.4656 17.6349H7.26687L11.6131 2.47884H16.2825C16.4051 2.47884 16.5054 2.37854 16.5054 2.25595V0.472884C16.5054 0.350298 16.4051 0.25 16.2825 0.25Z"
      fill="#374151"
    />
  </svg>
);

export const InAppH1TextStyleIcon = () => (
  <svg
    className="w-[28px] h-[28px]"
    width="28"
    height="28"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3843 19.6262H14.6396V0.375H12.3843V8.81922H2.42329V0.375H0.167969V19.6262H2.42329V10.8464H12.3843V19.6262ZM20.205 19.6263H21.1662V11.0344H20.8028C20.6543 11.1633 20.4785 11.2961 20.2753 11.4329C20.0722 11.5657 19.8553 11.6947 19.6248 11.8197C19.3982 11.9408 19.1657 12.0522 18.9274 12.1538C18.693 12.2514 18.4703 12.3296 18.2593 12.3882V13.3611C18.4468 13.3142 18.6383 13.2497 18.8336 13.1677C19.0329 13.0856 19.2204 12.9977 19.3962 12.9039C19.576 12.8102 19.7362 12.7164 19.8768 12.6226C20.0214 12.525 20.1308 12.439 20.205 12.3648V19.6263Z"
      fill="#374151"
    />
  </svg>
);

export const InAppLinkTextStyleIcon = () => (
  <svg
    className="w-[28px] h-[28px]"
    width="28"
    height="28"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6973 15.1966C12.6562 15.1559 12.6006 15.1331 12.5428 15.1331C12.4849 15.1331 12.4294 15.1559 12.3883 15.1966L9.21078 18.3741C7.73961 19.8453 5.25668 20.0011 3.63238 18.3741C2.00535 16.7471 2.16121 14.2669 3.63238 12.7957L6.80988 9.61822C6.89465 9.53345 6.89465 9.39399 6.80988 9.30922L5.72154 8.22088C5.68043 8.18017 5.6249 8.15733 5.56704 8.15733C5.50918 8.15733 5.45366 8.18017 5.41254 8.22088L2.23505 11.3984C-0.0783485 13.7118 -0.0783485 17.4553 2.23505 19.766C4.54844 22.0766 8.29198 22.0794 10.6026 19.766L13.7801 16.5885C13.8649 16.5037 13.8649 16.3643 13.7801 16.2795L12.6973 15.1966ZM19.7687 2.23505C17.4553 -0.0783486 13.7118 -0.0783486 11.4011 2.23505L8.22088 5.41254C8.18017 5.45366 8.15733 5.50918 8.15733 5.56704C8.15733 5.62491 8.18017 5.68043 8.22088 5.72154L9.30648 6.80714C9.39125 6.89191 9.53071 6.89191 9.61548 6.80714L12.793 3.62964C14.2641 2.15848 16.7471 2.00261 18.3714 3.62964C19.9984 5.25668 19.8425 7.73688 18.3714 9.20804L15.1939 12.3855C15.1532 12.4267 15.1303 12.4822 15.1303 12.54C15.1303 12.5979 15.1532 12.6534 15.1939 12.6945L16.2822 13.7829C16.367 13.8676 16.5064 13.8676 16.5912 13.7829L19.7687 10.6054C22.0794 8.29198 22.0794 4.54844 19.7687 2.23505ZM13.6844 7.18177C13.6433 7.14106 13.5878 7.11822 13.5299 7.11822C13.4721 7.11822 13.4165 7.14106 13.3754 7.18177L7.18177 13.3727C7.14106 13.4138 7.11822 13.4693 7.11822 13.5272C7.11822 13.5851 7.14106 13.6406 7.18177 13.6817L8.26464 14.7646C8.3494 14.8493 8.48887 14.8493 8.57364 14.7646L14.7646 8.57364C14.8493 8.48887 14.8493 8.34941 14.7646 8.26464L13.6844 7.18177Z"
      fill="#374151"
    />
  </svg>
);

export const InAppMediaPositionTopIcon = () => (
  <svg viewBox="0 0 25 20" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M22.916 19.5H2.083C.933 19.5 0 18.605 0 17.5v-15c0-1.105.932-2 2.083-2h20.833c1.15 0 2.084.895 2.084 2v15c0 1.105-.933 2-2.084 2zm-.833-1H2.916C1.858 18.5 1 17.699 1 16.71V3.29C1 2.3 1.858 1.5 2.916 1.5h19.167C23.14 1.5 24 2.301 24 3.29v13.42c0 .989-.859 1.79-1.917 1.79z"
        fill="#374151"
      ></path>
      <g stroke="#374151" strokeLinecap="square">
        <path d="M4.5 13.5h16M4.5 15.5h16"></path>
      </g>
      <path
        d="M10.362 5.026l4.5 2.25a.25.25 0 0 1 0 .448l-4.5 2.25A.25.25 0 0 1 10 9.75v-4.5a.25.25 0 0 1 .362-.224z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppMediaPositionRightIcon = () => (
  <svg viewBox="0 0 25 19" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M22.917 19H2.083C.933 19 0 18.105 0 17V2C0 .895.933 0 2.083 0h20.834C24.067 0 25 .895 25 2v15c0 1.105-.933 2-2.083 2zm-20-1C1.858 18 1 17.199 1 16.21V2.79C1 1.8 1.858 1 2.917 1h19.166C23.142 1 24 1.801 24 2.79v13.42c0 .989-.858 1.79-1.917 1.79H2.917z"
        fill="#374151"
      ></path>
      <g stroke="#374151" strokeLinecap="square">
        <path d="M4.206 5.5h6.588M4.206 7.5h6.588"></path>
      </g>
      <g stroke="#374151" strokeLinecap="square">
        <path d="M4.206 10.5h6.588M4.206 12.5h6.588"></path>
      </g>
      <path
        d="M16.362 7.026l4.5 2.25a.25.25 0 0 1 0 .448l-4.5 2.25A.25.25 0 0 1 16 11.75v-4.5a.25.25 0 0 1 .362-.224z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppMediaPositionBotIcon = () => (
  <svg viewBox="0 0 25 20" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M22.916 19.5H2.083C.933 19.5 0 18.605 0 17.5v-15c0-1.105.932-2 2.083-2h20.833c1.15 0 2.084.895 2.084 2v15c0 1.105-.933 2-2.084 2zm-.833-1H2.916C1.858 18.5 1 17.699 1 16.71V3.29C1 2.3 1.858 1.5 2.916 1.5h19.167C23.14 1.5 24 2.301 24 3.29v13.42c0 .989-.859 1.79-1.917 1.79z"
        fill="#374151"
      ></path>
      <g stroke="#374151" strokeLinecap="square">
        <path d="M4.5 5.5h16M4.5 7.5h16"></path>
      </g>
      <path
        d="M10.362 11.026l4.5 2.25a.25.25 0 0 1 0 .448l-4.5 2.25A.25.25 0 0 1 10 15.75v-4.5a.25.25 0 0 1 .362-.224z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppMediaPositionLeftIcon = () => (
  <svg viewBox="0 0 25 19" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M22.917 19H2.083C.933 19 0 18.105 0 17V2C0 .895.933 0 2.083 0h20.834C24.067 0 25 .895 25 2v15c0 1.105-.933 2-2.083 2zm-20-1C1.858 18 1 17.199 1 16.21V2.79C1 1.8 1.858 1 2.917 1h19.166C23.142 1 24 1.801 24 2.79v13.42c0 .989-.858 1.79-1.917 1.79H2.917z"
        fill="#374151"
      ></path>
      <g stroke="#374151" strokeLinecap="square">
        <path d="M14.206 5.5h6.588M14.206 7.5h6.588"></path>
      </g>
      <g stroke="#374151" strokeLinecap="square">
        <path d="M14.206 10.5h6.588M14.206 12.5h6.588"></path>
      </g>
      <path
        d="M5.362 7.026l4.5 2.25a.25.25 0 0 1 0 .448l-4.5 2.25A.25.25 0 0 1 5 11.75v-4.5a.25.25 0 0 1 .362-.224z"
        fill="#374151"
      ></path>
    </g>
  </svg>
);

export const InAppMediaActionClickNone = () => (
  <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.01 54.02c-13.255 0-24-10.744-24-24 0-13.254 10.745-24 24-24s24 10.746 24 24c0 13.256-10.745 24-24 24zm0-44c-11.046 0-20 8.955-20 20 0 11.046 8.954 20 20 20s20-8.954 20-20c0-11.045-8.954-20-20-20z"
      fill="#374151"
      fillRule="evenodd"
    ></path>
  </svg>
);

export const InAppMediaActionClickComplete = () => (
  <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.01 54.02c-13.255 0-24-10.744-24-24 0-13.254 10.745-24 24-24s24 10.746 24 24c0 13.256-10.745 24-24 24zm9.56-35.406c-.08.082-.153.17-.218.263l-12.844 18.39-5.874-8.41a2.001 2.001 0 0 0-3.05-.279 2.085 2.085 0 0 0-.17 2.67l6.624 9.485a3.014 3.014 0 0 0 4.94 0L42.572 21.27a2.085 2.085 0 0 0-.171-2.67 2.001 2.001 0 0 0-2.83.015z"
      fill="#374151"
      fillRule="evenodd"
    ></path>
  </svg>
);

export const InAppDismissPositionOutRight = () => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 33 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#374151" fillRule="evenodd">
      <path d="M22.916 19.5H2.083C.933 19.5 0 18.605 0 17.5v-15c0-1.105.932-2 2.083-2h20.833c1.15 0 2.084.895 2.084 2v15c0 1.105-.933 2-2.084 2zm-.833-1H2.916C1.858 18.5 1 17.699 1 16.71V3.29C1 2.3 1.858 1.5 2.916 1.5h19.167C23.14 1.5 24 2.301 24 3.29v13.42c0 .989-.859 1.79-1.917 1.79zM30.735 4.507l1.999 2.003a.873.873 0 1 1-1.233 1.235l-2-2.003-1.998 2.003A.873.873 0 0 1 26.27 6.51l1.999-2.003-2.013-2.017a.873.873 0 1 1 1.233-1.235l2.013 2.017 2.013-2.017a.873.873 0 0 1 1.232 1.235l-2.012 2.017z"></path>
    </g>
  </svg>
);

export const InAppDismissPositionOutLeft = () => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 33 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#374151" fillRule="evenodd">
      <path d="M30.916 19.5H10.083c-1.15 0-2.083-.895-2.083-2v-15c0-1.105.932-2 2.083-2h20.833c1.15 0 2.084.895 2.084 2v15c0 1.105-.933 2-2.084 2zm-.833-1H10.916C9.858 18.5 9 17.699 9 16.71V3.29c0-.989.858-1.79 1.916-1.79h19.167C31.14 1.5 32 2.301 32 3.29v13.42c0 .989-.859 1.79-1.917 1.79zM6.747 2.49L4.735 4.507 6.734 6.51a.873.873 0 1 1-1.233 1.235l-2-2.003-1.998 2.003A.873.873 0 0 1 .27 6.51L2.27 4.507.256 2.49A.873.873 0 1 1 1.49 1.255l2.013 2.017 2.013-2.017A.873.873 0 0 1 6.747 2.49z"></path>
    </g>
  </svg>
);

export const InAppDismissPositionInRight = () => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 25 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#374151" fillRule="evenodd">
      <path d="M22.917 19H2.083C.933 19 0 18.105 0 17V2C0 .895.933 0 2.083 0h20.834C24.067 0 25 .895 25 2v15c0 1.105-.933 2-2.083 2zm-20-1C1.858 18 1 17.199 1 16.21V2.79C1 1.8 1.858 1 2.917 1h19.166C23.142 1 24 1.801 24 2.79v13.42c0 .989-.858 1.79-1.917 1.79H2.917z"></path>
      <path d="M20.735 5.507l1.999 2.003a.873.873 0 1 1-1.233 1.235l-2-2.003-1.998 2.003A.873.873 0 0 1 16.27 7.51l1.999-2.003-2.013-2.017a.873.873 0 1 1 1.233-1.235l2.013 2.017 2.013-2.017a.873.873 0 0 1 1.232 1.235l-2.012 2.017z"></path>
    </g>
  </svg>
);

export const InAppDismissPositionInLeft = () => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 25 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#374151" fillRule="evenodd">
      <path d="M22.917 19H2.083C.933 19 0 18.105 0 17V2C0 .895.933 0 2.083 0h20.834C24.067 0 25 .895 25 2v15c0 1.105-.933 2-2.083 2zm-20-1C1.858 18 1 17.199 1 16.21V2.79C1 1.8 1.858 1 2.917 1h19.166C23.142 1 24 1.801 24 2.79v13.42c0 .989-.858 1.79-1.917 1.79H2.917z"></path>
      <path d="M6.735 5.507L8.734 7.51a.873.873 0 1 1-1.233 1.235l-2-2.003-1.998 2.003A.873.873 0 0 1 2.27 7.51L4.27 5.507 2.256 3.49A.873.873 0 1 1 3.49 2.255l2.013 2.017 2.013-2.017A.873.873 0 0 1 8.747 3.49L6.735 5.507z"></path>
    </g>
  </svg>
);

export const InAppDismissPositionCenterRight = () => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 25 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#374151" fillRule="evenodd">
      <path d="M22.917 19H2.083C.933 19 0 18.105 0 17V2C0 .895.933 0 2.083 0h20.834C24.067 0 25 .895 25 2v15c0 1.105-.933 2-2.083 2zm-20-1C1.858 18 1 17.199 1 16.21V2.79C1 1.8 1.858 1 2.917 1h19.166C23.142 1 24 1.801 24 2.79v13.42c0 .989-.858 1.79-1.917 1.79H2.917z"></path>
      <path d="M20.735 9.507l1.999 2.003a.873.873 0 1 1-1.233 1.235l-2-2.003-1.998 2.003a.873.873 0 0 1-1.233-1.235l1.999-2.003-2.013-2.017a.873.873 0 1 1 1.233-1.235l2.013 2.017 2.013-2.017a.873.873 0 0 1 1.232 1.235l-2.012 2.017z"></path>
    </g>
  </svg>
);

export const InAppDismissPositionCenterLeft = () => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 25 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#374151" fillRule="evenodd">
      <path d="M22.917 19H2.083C.933 19 0 18.105 0 17V2C0 .895.933 0 2.083 0h20.834C24.067 0 25 .895 25 2v15c0 1.105-.933 2-2.083 2zm-20-1C1.858 18 1 17.199 1 16.21V2.79C1 1.8 1.858 1 2.917 1h19.166C23.142 1 24 1.801 24 2.79v13.42c0 .989-.858 1.79-1.917 1.79H2.917z"></path>
      <path d="M6.735 9.507l1.999 2.003a.873.873 0 1 1-1.233 1.235l-2-2.003-1.998 2.003A.873.873 0 0 1 2.27 11.51L4.27 9.507 2.256 7.49A.873.873 0 1 1 3.49 6.255l2.013 2.017 2.013-2.017A.873.873 0 0 1 8.747 7.49L6.735 9.507z"></path>
    </g>
  </svg>
);

export const InAppPrimaryPositionBottomLeft = () => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 26 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.68401 16.7895C3.24822 16.7895 2.89453 16.6107 2.89453 16.3903V13.3992C2.89453 13.1781 3.24822 13 3.68401 13H11.5787C12.0145 13 12.3682 13.1787 12.3682 13.3992V16.3903C12.3682 16.6114 12.0145 16.7895 11.5787 16.7895H3.68401Z"
      stroke="#374151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9998 18.6842H3.00021C1.89495 18.6842 1 17.8505 1 16.8229V2.86126C1 1.83368 1.89558 1 3.00021 1H22.9998C24.1051 1 25 1.83368 25 2.86126V16.8229C25 17.8505 24.1044 18.6842 22.9998 18.6842Z"
      stroke="#374151"
      strokeWidth="1.5"
    />
  </svg>
);

export const InAppPrimaryPositionBottomCenter = () => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 27 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0356 16.7895C9.59978 16.7895 9.24609 16.6107 9.24609 16.3903V13.3992C9.24609 13.1781 9.59978 13 10.0356 13H17.9303C18.3661 13 18.7198 13.1787 18.7198 13.3992V16.3903C18.7198 16.6114 18.3661 16.7895 17.9303 16.7895H10.0356Z"
      stroke="#374151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.6678 18.6842H3.66818C2.56292 18.6842 1.66797 17.8505 1.66797 16.8229V2.86126C1.66797 1.83368 2.56355 1 3.66818 1H23.6678C24.773 1 25.668 1.83368 25.668 2.86126V16.8229C25.668 17.8505 24.7724 18.6842 23.6678 18.6842Z"
      stroke="#374151"
      strokeWidth="1.5"
    />
  </svg>
);

export const InAppPrimaryPositionBottomRight = () => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 27 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7543 16.7895C14.3185 16.7895 13.9648 16.6107 13.9648 16.3903V13.3992C13.9648 13.1781 14.3185 13 14.7543 13H22.6491C23.0848 13 23.4385 13.1787 23.4385 13.3992V16.3903C23.4385 16.6114 23.0848 16.7895 22.6491 16.7895H14.7543Z"
      stroke="#374151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3318 18.6842H3.33224C2.22698 18.6842 1.33203 17.8505 1.33203 16.8229V2.86126C1.33203 1.83368 2.22761 1 3.33224 1H23.3318C24.4371 1 25.332 1.83368 25.332 2.86126V16.8229C25.332 17.8505 24.4365 18.6842 23.3318 18.6842Z"
      stroke="#374151"
      strokeWidth="1.5"
    />
  </svg>
);

export const InAppPrimaryPositionCenterRight = () => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 26 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4223 11.7367C13.9865 11.7367 13.6328 11.558 13.6328 11.3376V8.34642C13.6328 8.12537 13.9865 7.94727 14.4223 7.94727H22.317C22.7528 7.94727 23.1065 8.126 23.1065 8.34642V11.3376C23.1065 11.5586 22.7528 11.7367 22.317 11.7367H14.4223Z"
      stroke="#374151"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9998 18.6842H3.00021C1.89495 18.6842 1 17.8505 1 16.8229V2.86126C1 1.83368 1.89558 1 3.00021 1H22.9998C24.1051 1 25 1.83368 25 2.86126V16.8229C25 17.8505 24.1044 18.6842 22.9998 18.6842Z"
      stroke="#374151"
      strokeWidth="1.5"
    />
  </svg>
);

export const AdditionalActionGeneralIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.46838 0.375977H5.53088C5.44755 0.375977 5.40588 0.417643 5.40588 0.500977V5.40723H0.75C0.666667 5.40723 0.625 5.44889 0.625 5.53223V6.46973C0.625 6.55306 0.666667 6.59473 0.75 6.59473H5.40588V11.501C5.40588 11.5843 5.44755 11.626 5.53088 11.626H6.46838C6.55172 11.626 6.59338 11.5843 6.59338 11.501V6.59473H11.25C11.3333 6.59473 11.375 6.55306 11.375 6.46973V5.53223C11.375 5.44889 11.3333 5.40723 11.25 5.40723H6.59338V0.500977C6.59338 0.417643 6.55172 0.375977 6.46838 0.375977Z"
      fill="#374151"
    />
  </svg>
);
